import style from "./RequestReceiptForm.module.css";
import logo from "../../../assets/images/logo-hacom-2024.png";
import logoDVT from "../../../assets/images/logoDVT.svg";
import { IconCheckbox, IconSquare } from "@tabler/icons-react";

const PrinterRequestReceiptForm = ({
  innerRef,
  dataPrint,
}: {
  innerRef: any;
  dataPrint: any;
}) => {
  console.log(dataPrint);

  return (
    <div ref={innerRef} className={style.main}>
      <div
        className={
          dataPrint?.companyCode === "DVT"
            ? `${style.header} ${style.bdRed}`
            : `${style.header}`
        }
      >
        <img
          className={
            // dataPrint?.branchId === 222 || dataPrint?.branchId === 223
            dataPrint?.companyCode === "DVT" ? `${style.customImg}` : ""
          }
          src={
            // dataPrint?.branchId === 222 || dataPrint?.branchId === 223
            dataPrint?.companyCode === "DVT" ? logoDVT : logo
          }
          alt={dataPrint?.companyCode === "DVT" ? "logoDVT" : "logo Hacom"}
          width={
            // dataPrint?.branchId === 222 || dataPrint?.branchId === 223
            dataPrint?.companyCode === "DVT" ? 225 : 150
          }
          height={
            // dataPrint?.branchId === 222 || dataPrint?.branchId === 223
            dataPrint?.companyCode === "DVT" ? 50 : "auto"
          }
          style={{
            objectFit: "contain",
          }}
        />
        <div>
          <div className={style.line}>
            <h3>
              {" "}
              {dataPrint?.companyCode === "DVT"
                ? "CÔNG TY CỔ PHẦN HACOM DỊCH VỤ TỐT"
                : "CÔNG TY CỔ PHẦN ĐẦU TƯ CÔNG NGHỆ HACOM"}
            </h3>
          </div>
          <div className={style.line}>
            <p className={style.cText}>Trụ sở: </p>
            <p>
              {" "}
              {dataPrint?.companyCode === "DVT"
                ? " Số 65 Thái Hà, P.Trung Liệt, Q.Đống Đa, TP.Hà Nội"
                : "129+131 Lê Thanh Nghị, Q.Hai Bà Trưng, TP.Hà Nội"}
            </p>
          </div>
          <div className={style.line}>
            <div>
              <p className={style.cText}>Tel: </p>
              <p>
                {" "}
                {dataPrint?.companyCode === "DVT" ? "1800 8091" : "1900 1903"}
              </p>
            </div>
            <div>
              <p className={style.cText}>Email:</p>
              <p>
                {" "}
                {dataPrint?.companyCode === "DVT"
                  ? "info@dichvutot.vn."
                  : "info@hacom.vn"}
              </p>
            </div>
          </div>
          <div className={style.line}>
            <p className={style.cText}>Website:</p>
            <p>
              {" "}
              {dataPrint?.companyCode === "DVT"
                ? "www.dichvutot.vn"
                : "www.hacom.vn"}
            </p>
          </div>
        </div>
      </div>
      <div className={style.body}>
        <div>
          <h2>PHIẾU TIẾP NHẬN YÊU CẦU</h2>
          <p style={{ fontStyle: "italic", marginTop: "-20px" }}>
            Số phiếu:{" "}
            {dataPrint?.attribute10 !== null && dataPrint?.attribute10 !== ""
              ? dataPrint?.attribute10
              : "Không có số phiếu"}
          </p>
        </div>
        <div>
          <div className={style.infoForm}>
            <div>
              <div>
                <p>Mã phiếu tiếp nhận yêu cầu:</p>
                <p>{dataPrint?.requestNum}</p>
              </div>
              <div>
                <p>Nhân viên tiếp nhận:</p>
                <p>{dataPrint?.createByName}</p>
              </div>
              <div>
                <p>Bộ phận/Phòng ban:</p>
                <p>{dataPrint?.depname}</p>
              </div>
            </div>
            <div>
              <div>
                <p>Ngày tiếp nhận:</p>
                <p>
                  {" "}
                  {String(new Date(dataPrint?.createDate).getDate()).padStart(
                    2,
                    "0",
                  )}
                  /
                  {String(
                    new Date(dataPrint?.createDate).getMonth() + 1,
                  ).padStart(2, "0")}
                  /{new Date(dataPrint?.createDate).getFullYear()}{" "}
                  {String(new Date(dataPrint?.createDate).getHours()).padStart(
                    2,
                    "0",
                  )}
                  :
                  {String(
                    new Date(dataPrint?.createDate).getMinutes(),
                  ).padStart(2, "0")}
                </p>
              </div>
              <div>
                <p>Chức danh:</p>
                <p>{dataPrint?.rolename}</p>
              </div>
              <div>
                <p>Chi nhánh xử lý yêu cầu:</p>
                <p>{dataPrint?.branchName}</p>
              </div>
            </div>
          </div>
          <div className={style.mainProcessingMethod}>
            <p className={style.processingMethod}>Hình thức xử lý:</p>
            <div>
              {dataPrint?.processingMethodName === "Xử lý từ xa" ? (
                <IconCheckbox size={14} />
              ) : (
                <IconSquare size={14} />
              )}
              <p>Xử lý từ xa</p>
            </div>
            <div>
              {dataPrint?.processingMethodName === "Xử lý tại CH/CN" ? (
                <IconCheckbox size={14} />
              ) : (
                <IconSquare size={14} />
              )}
              <p>Xử lý tại CH/CN</p>
            </div>
            <div>
              {dataPrint?.processingMethodName === "Xử lý tại nhà" ? (
                <IconCheckbox size={14} />
              ) : (
                <IconSquare size={14} />
              )}
              <p>Xử lý tại nhà</p>
            </div>
          </div>
        </div>
        <h3 className={style.titleCust}>Thông tin khách hàng</h3>
        <div className={style.infoCust}>
          <div className={style.nameAndPhone}>
            <div>
              <p>Khách hàng hẹn gặp:</p>
              <p>{dataPrint?.custMeeting}</p>
            </div>
            <div>
              <p>Số điện thoại:</p>
              <p>{dataPrint?.custPhone}</p>
            </div>
          </div>
          <div className={style.addr}>
            <p>Địa chỉ:</p>
            <p>
              {[dataPrint?.additionalAddress, dataPrint?.meetingAddress]
                .filter((i) => i && String(i).length > 0)
                .join(" - ")}
            </p>
          </div>
        </div>
        <h3 className={style.titleCust}>Thông tin sản phẩm</h3>
        <table className={style.table}>
          <thead>
            <tr>
              <th>Serial</th>
              <th>Tên sản phẩm</th>
              <th>Mã sản phẩm</th>
              <th>Đơn vị tính</th>
              <th>Thời hạn bảo hành</th>
              <th>Tình trạng ban đầu</th>
              <th>Loại dịch vụ</th>
            </tr>
          </thead>
          <tbody>
            {dataPrint?.tblWarrantyServiceRequestFormDetailModels?.map(
              (item: any, index: any) => (
                <tr key={index}>
                  <td>{item.serial}</td>
                  <td>{item.itemName}</td>
                  <td>{item.itemCode}</td>
                  <td>{item.uomName}</td>
                  <td>{item.warrantyTerm} tháng</td>
                  <td>{item.listErrorCode}</td>
                  <td>{item.serviceType}</td>
                </tr>
              ),
            )}
          </tbody>
        </table>
        <div className={style.note}>
          <p>Ghi chú:</p>
          <p>{dataPrint?.content}</p>
        </div>
        <div className={style.importantNote}>
          <p className={style.fw}>Lưu ý quan trọng miễn trừ trách nhiệm:</p>
          <p>Phiếu tiếp nhận này có</p>
          <p className={style.fw}>giá trị trong vòng 30 ngày</p>
          <p>
            sau thời gian này sản phẩm không được quý khách hàng nhận lại sẽ
            được xử lý hủy theo Quy định của{" "}
            {dataPrint?.companyCode === "DVT"
              ? "Công ty cổ phần HACOM Dịch Vụ Tốt"
              : "Công ty Cổ phần Đầu tư Công nghệ HACOM"}{" "}
            .
          </p>
          <p className={style.fw}>
            {dataPrint?.companyCode === "DVT" ? "HACOM Dịch Vụ Tốt" : "HACOM"}{" "}
            không chịu trách nhiệm trong mọi trường hợp về dữ liệu, phần mềm
            chuyên dụng.
          </p>
        </div>
        <div className={style.importantNote}>
          <p className={style.fw}>
            Quý khách khi nhận lại sản phẩm phải có phiếu này.
          </p>
          <p>
            Mọi chi tiết xin liên hệ{" "}
            {dataPrint?.companyCode === "DVT" ? "18008091" : "19001903"} phím 3.
          </p>
        </div>
        <div className={style.daySignature}>
          <div>
            <p>{"               "}</p>
          </div>
          <div>
            <p className={style.fw}>
              Hà Nội, ngày {String(new Date().getDate()).padStart(2, "0")} tháng{" "}
              {String(new Date().getMonth() + 1).padStart(2, "0")} năm{" "}
              {new Date().getFullYear()}
            </p>
          </div>
        </div>
        <div className={style.signature}>
          <div>
            <p className={style.fw}>Khách gửi</p>
            <p>
              {"("}Ký & ghi rõ họ tên{")"}
            </p>
          </div>
          {dataPrint?.companyCode === "DVT" ? (
            <div>
              <p className={style.fw}>Khách nhận lại</p>
              <p>
                {"("}Ký & ghi rõ họ tên{")"}
              </p>
            </div>
          ) : (
            <></>
          )}
          <div>
            <p className={style.fw}>Kỹ thuật tiếp nhận</p>
            <p>
              {"("}Ký & ghi rõ họ tên{")"}
            </p>
          </div>
          {dataPrint?.companyCode === "DVT" ? (
            <div>
              <p className={style.fw}>Kỹ thuật xuất trả</p>
              <p>
                {"("}Ký & ghi rõ họ tên{")"}
              </p>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};

export default PrinterRequestReceiptForm;
